import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, ViewChild, forwardRef, ChangeDetectionStrategy, OnInit } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { ControlValueAccessorDirective } from '@shared/directives/control-value-accessor.directive';
import { InputControlDirective } from '@shared/directives/input-control.directive';
import { ValidationPatterns } from 'app/modules/core/constants/core.constants';
import { NgxMaskDirective } from 'ngx-mask';

@Component({
  selector: 'app-input',
  templateUrl: './input.component.html',
  styleUrls: ['./input.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CommonModule,
    NgxMaskDirective,
    InputControlDirective,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    MatIconModule,
    MatCardModule
  ],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: forwardRef(() => InputComponent)
    }
  ]
})
export class InputComponent<T> extends ControlValueAccessorDirective<T> implements OnInit {
  // CONTROL NEEDS TO HAVE SOME OF CONTROL DIRECTIVES (NgModel, FormControl) so it could work properly  !!!!!!!!!!!!!!!!
  @Input() enableSearch = true;
  @Input() showLabel = true;
  @Input() showAsterisk = true;
  @Input() label: string; // Label;
  @Input() placeholder = '';
  @Input() mask = '';
  @Input() icon = '';
  @Input() cols = '75';
  @Input() rows = '7';
  @Input() prefix = '';
  @Input() dropSpecialCharacters = false;
  @Input() controlRegex: RegExp | string = '';
  @Input() minlength = 1;
  @Input() minValue = 0;
  @Input() controlType: 'text' | 'textarea' | 'number' | 'password' | 'checkbox' | 'email' | 'mask' | 'currency' =
    'text';
  @Input() readonly = false;

  @ViewChild('controlInput') controlInput: ElementRef;
  validationPatterns = this.controlRegex === '' ? ValidationPatterns.numbers : RegExp(this.controlRegex);

  ngOnInit(): void {
    super.ngOnInit();
  }

  // HostListener declared in base class
  clickedOutside(event: Event) {
    super.clickedOutside(event);
    if ((this.controlInput?.nativeElement as HTMLElement)?.children) {
      const exists = Array.from((this.controlInput?.nativeElement as HTMLElement)?.children).find(
        item => item === event.target
      );
      if (exists) this.isTouched = true;
    }
  }
}
